import { createAction, createReducer } from "@reduxjs/toolkit";

// Initial State
const initialState = {
  name: "",
  billingCountry: null,
  province: null,
  address: "",
  city: "",
  zip: "",
  pwywSuggestedPrice: process.env.GATSBY_PWYW_SUGGESTED_PRICE,
  pwywMinimumPrice: process.env.GATSBY_PWYW_MINIMUM_PRICE,
  premiumCourseSuggestedPrice: process.env.GATSBY_PREMIUM_COURSE_SUGGESTED_PRICE,
  premiumCourseMinimumPrice: process.env.GATSBY_PREMIUM_COURSE_MINIMUM_PRICE,
};

// Actions
export const setName = createAction("SET_NAME");
export const setBillingCountry = createAction("SET_BILLING_COUNTRY");
export const setProvince = createAction("SET_PROVINCE");
export const setAddress = createAction("SET_ADDRESS");
export const setCity = createAction("SET_CITY");
export const setZip = createAction("SET_ZIP");
export const setPwywSuggestedPrice = createAction("SET_PWYW_SUGGESTED_PRICE");
export const setPremiumCourseSuggestedPrice = createAction(
  "SET_PREMIUM_COURSE_SUGGESTED_PRICE"
);
export const setPwywMinimumPrice = createAction("SET_PWYW_MINIMUM_PRICE");
export const setPremiumCourseMinimumPrice = createAction(
  "SET_PREMIUM_COURSE_MINIMUM_PRICE"
);

// Reducer
const paymentReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setName, (state, action) => {
      state.name = action.payload;
    })
    .addCase(setBillingCountry, (state, action) => {
      state.billingCountry = action.payload;
    })
    .addCase(setProvince, (state, action) => {
      state.province = action.payload;
    })
    .addCase(setAddress, (state, action) => {
      state.address = action.payload;
    })
    .addCase(setCity, (state, action) => {
      state.city = action.payload;
    })
    .addCase(setZip, (state, action) => {
      state.zip = action.payload;
    })
    .addCase(setPwywSuggestedPrice, (state, action) => {
      state.pwywSuggestedPrice = action.payload;
    })
    .addCase(setPremiumCourseSuggestedPrice, (state, action) => {
      state.premiumCourseSuggestedPrice = action.payload;
    })
    .addCase(setPwywMinimumPrice, (state, action) => {
      state.pwywMinimumPrice = action.payload;
    })
    .addCase(setPremiumCourseMinimumPrice, (state, action) => {
      state.premiumCourseMinimumPrice = action.payload;
    });
});

export default paymentReducer;
